import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { ILaboratoryProjects } from "./routeType";

const { key, getPath } = getApi("members.laboratories.projects.get");

type IExtractedRouteType =
  ILaboratoryProjects["laboratoryProjectSingleRetrieve"];

export type IGetMemberLaboratoryProject = IPickSingleQuery<IExtractedRouteType>;

const getMemberLaboratoryProject: Fetcher<
  IGetMemberLaboratoryProject["response"],
  IGetMemberLaboratoryProject["variables"]
> = ({ labId, projectId, ...params }) => {
  return axiosClient.get(getPath({ labId, projectId }), { params });
};

export const useGetMemberLaboratoryProject = createQuery({
  queryKey: [key],
  fetcher: getMemberLaboratoryProject,
});
